import { createApiClient } from '@wix/premium-fed-sdk/@apis-infra-react';
import { PlanRecommendationQueriesConfig } from './plan-recommendation.queries';
export const PlanRecommendationApiClient = createApiClient(PlanRecommendationQueriesConfig);
//# sourceMappingURL=plan-recommendation.api-client.js.map